import { render, staticRenderFns } from "./GoogleWidget.vue?vue&type=template&id=22ed2c62&scoped=true"
import script from "./GoogleWidget.vue?vue&type=script&lang=js"
export * from "./GoogleWidget.vue?vue&type=script&lang=js"
import style0 from "./GoogleWidget.vue?vue&type=style&index=0&id=22ed2c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ed2c62",
  null
  
)

export default component.exports